export default __webpack_public_path__ + "static/media/playstore.4b59828d.png";